import SearchCard from "./SearchCard.js";
export default SearchCard;
